import { Card, Grid, Typography } from '@mui/material';
import { agendaCardTitleColor, agendaCardTitleFontColor } from 'config';
import { useSelector } from 'react-redux';


function AgendaCardTitle() {
    const columnData = [
        { id: 'siralama', align: 'center', disablePadding: false, label: 'Sıra', xsValue: 1 },
        { id: 'decisionNo', align: 'center', disablePadding: false, label: 'Gündem No', xsValue: 1 },
        { id: 'subjectId', align: 'center', disablePadding: false, label: 'Konu', xsValue: 3 },
        { id: 'department', align: 'center', disablePadding: false, label: 'İlgi Birim/Kurum', xsValue: 3 },
        { id: 'pdate', align: 'center', disablePadding: false, label: 'Tarih', xsValue: 2 },
        { id: 'otherInfos', align: 'center', disablePadding: false, label: 'Diğer Bilgiler', xsValue: 2 },


        // { id: 'supp', align: 'center', disablePadding: false, label: 'Ek Gündem', xsValue: 1 },
        // { id: 'principle', align: 'center', disablePadding: false, label: 'İlke Kararı', xsValue: 1 },
        // { id: 'yaysisMeetingId', align: 'center', disablePadding: true, label: 'Yaysis Id', xsValue: 1 },
        // { id: 'saysMeetingId', align: 'center', disablePadding: true, label: 'Says Id', xsValue: 1 },
    ];

    const fontSettings = useSelector((state) => state.meeting.fontSettings);
    const { agendaFontSize } = fontSettings


    return (
        <Card
            elevation={0}
            sx={{
                margin: 0,
                padding: '15px',
                // minHeight: '100px',
                // maxHeight: '100px',
                width: '100%',
                boxShadow: 'none',

                backgroundColor: agendaCardTitleColor
            }}
        >
            <Grid container>
                {columnData.map((item) => (
                    <Grid item xs={item.xsValue} key={item.id}>
                        <Typography color={agendaCardTitleFontColor} sx={{ fontSize: agendaFontSize, fontWeight: 'bold' }}>
                            {item.label}
                        </Typography>
                    </Grid>
                ))}
            </Grid>
        </Card>
    );
}

export default AgendaCardTitle;
